/**
 * Bonded Matter facet drawer: sort grid buttons drive hidden `sort_by` for `facet-form`.
 * When the drawer variant column is empty but the hidden vertical `#FacetFiltersContainer` still
 * renders storefront filters (same `collection.filters`), clone those `<details>` rows into the
 * drawer with `data-index` rewritten from `vertical-*` to `drawer-*` so `facets.js` can keep them in sync.
 */
(function () {
  const DRAWER_ID = 'FacetDrawer';

  function getDrawer() {
    return document.getElementById(DRAWER_ID);
  }

  /**
   * @returns {void}
   */
  function bmSyncFacetDrawerVariantsFromVertical() {
    const wrap = document.querySelector('#FacetFiltersContainerDrawer .bm-facet-drawer__variants-wrap');
    const vertical = document.getElementById('FacetFiltersContainer');
    if (!wrap || !vertical) return;

    if (wrap.querySelector(':scope > .bm-facet-drawer__variant-shell:not(.bm-facet-drawer__variant-shell--from-vertical)')) {
      return;
    }

    wrap.querySelectorAll(':scope > .bm-facet-drawer__variant-shell--from-vertical').forEach(function (n) {
      n.remove();
    });

    const catWrap = document.querySelector('#FacetFiltersContainerDrawer .bm-facet-drawer__categories-wrap[data-filter]');
    const drawerCatIdx = catWrap && catWrap.dataset ? catWrap.dataset.index : '';

    vertical.querySelectorAll('details.facet-accordion-details[data-filter][data-index^="vertical-"]').forEach(function (src) {
      const idx = src.dataset.index || '';
      if (!idx.startsWith('vertical-')) return;
      const drawerIdx = idx.replace(/^vertical/, 'drawer');
      const lower = drawerIdx.toLowerCase();
      if (lower.includes('filter.v.price')) return;
      if (lower.includes('availability')) return;
      if (drawerCatIdx && drawerIdx === drawerCatIdx) return;

      const clone = src.cloneNode(true);
      clone.removeAttribute('data-filter');
      clone.removeAttribute('data-index');
      clone.querySelectorAll('[id]').forEach(function (el) {
        el.removeAttribute('id');
      });

      const shell = document.createElement('div');
      shell.className = 'bm-facet-drawer__variant-shell bm-facet-drawer__variant-shell--from-vertical';
      shell.setAttribute('data-filter', '');
      shell.dataset.index = drawerIdx;
      shell.appendChild(clone);
      wrap.appendChild(shell);
    });
  }

  window.bmSyncFacetDrawerVariantsFromVertical = bmSyncFacetDrawerVariantsFromVertical;

  document.addEventListener('drawer:handleAfterShow', function (event) {
    const t = event.target;
    if (t && t.id === DRAWER_ID) {
      bmSyncFacetDrawerVariantsFromVertical();
    }
  });

  document.addEventListener('click', function (event) {
    const drawer = getDrawer();
    if (!drawer || !drawer.contains(event.target)) return;

    const btn = event.target.closest('[data-bm-drawer-sort-value]');
    if (!btn || btn.disabled) return;

    const form = btn.closest('form[is="facet-form"]');
    if (!form) return;

    const input = form.querySelector('#BMFacetDrawerSortInput');
    if (!input || input.tagName !== 'INPUT') return;

    const value = btn.getAttribute('data-bm-drawer-sort-value');
    if (value == null || value === '') return;

    input.value = value;

    const grid = btn.closest('.bm-facet-drawer__sort-grid');
    if (grid) {
      grid.querySelectorAll('[data-bm-drawer-sort-value]').forEach(function (b) {
        const active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
